import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';
import { passwordChecksV9 } from '../helpers/passwordPolicyV9';
import './PasswordRequirementsV9.css';

const PasswordRequirementsV9 = ({ password = '', optional = false }) => {
  const { t } = useTranslation();
  const checks = passwordChecksV9(password);
  return (
    <div
      className='password-requirements-v9'
      aria-live='polite'
      aria-atomic='true'
    >
      <p>{t(optional ? 'password_v9.optional' : 'password_v9.hint')}</p>
      <ul aria-label={t('password_v9.checklist')}>
        {Object.entries(checks).map(([condition, met]) => (
          <li key={condition} data-condition={condition} data-met={met}>
            <Icon
              name={met ? 'check circle' : 'circle outline'}
              aria-hidden='true'
            />
            <span className='password-requirements-status-v9'>
              {t(met ? 'password_v9.met' : 'password_v9.unmet')}:{' '}
            </span>
            {t('password_v9.' + condition)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirementsV9;
